module.exports = __webpack_public_path__ + "img/CutoutImage2.aa4747f1.png";